import httpClient from '../httpClient';

const login = async (data) => {
  try {
    let response = await httpClient.post(`${process.env.REACT_APP_API_HOST}/token/auth/`, data);
    window.localStorage["access_token"] = response.data.data.token;
    window.localStorage["username"] = response.data.data.attributes.username;
    window.localStorage["email"] = response.data.data.attributes.email;
    window.localStorage["id"] = response.data.data.id;

    return true;
  } catch (err){
    console.log(err);
    return false;
  }
};

export {
  login
};
